import { createStandardAction } from 'typesafe-actions';

export const updateReportCount = createStandardAction('REPORT_UPDATE_COUNT')<
  number
>();
